import React from 'react'
import PropTypes from 'prop-types'

const ItemizeSymbol = ({ style, width = 33, height = 33 }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    style={style}
    width={width}
    height={height}
    viewBox="0 0 30 30"
  >
    <g fill="#FFF" fillRule="nonzero">
      <path d="M21.136 15.799H8.976a.958.958 0 0 1-.947-.97c0-.536.424-.97.946-.97h12.161c.523 0 .946.434.946.97 0 .535-.423.97-.946.97zM21.136 11.305H8.976a.958.958 0 0 1-.947-.97c0-.536.424-.97.946-.97h12.161c.523 0 .946.434.946.97s-.423.97-.946.97zM21.136 20.394H8.976a.958.958 0 0 1-.947-.97c0-.536.424-.97.946-.97h12.161c.523 0 .946.434.946.97s-.423.97-.946.97z" />
      <path d="M16.917 26.922H6.742C4.714 26.922 3 25.15 3 23.05V6.848C3 4.727 4.674 3.005 6.742 3h16.493c2.042 0 3.703 1.726 3.703 3.848v20.017h-2.39V6.848c0-.784-.576-1.397-1.313-1.397H6.742a1.327 1.327 0 0 0-.962.407c-.255.263-.395.62-.39.99V23.05c0 .73.657 1.421 1.352 1.421h10.175v2.451z" />
    </g>
  </svg>
)

ItemizeSymbol.propTypes = {
  style: PropTypes.object,
  width: PropTypes.number,
  height: PropTypes.number,
}

export default ItemizeSymbol
